var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "el-fade-in" } }, [
    _vm.innerVisible
      ? _c(
          "div",
          {
            staticClass: "bloom-survey-mask",
            attrs: { id: "BloomSurveyDialog" },
            on: {
              click: function($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                $event.stopPropagation()
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "bloom-survey-dialog",
                attrs: { role: "dialog", "aria-modal": "true" }
              },
              [
                _c("div", { staticClass: "survey-header" }, [
                  _c("div", { staticClass: "header-top" }, [
                    _c("span", { staticClass: "survey-tag" }, [
                      _vm._v(_vm._s(_vm.$t("flowSurvey1")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "survey-close",
                        attrs: { type: "button", "aria-label": "close" },
                        on: { click: _vm.handleClose }
                      },
                      [_c("i", { staticClass: "close-icon" })]
                    )
                  ]),
                  _vm._v(" "),
                  _c("h3", { staticClass: "survey-title" }, [
                    _vm._v(_vm._s(_vm.$t("flowSurvey2")))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "survey-body" }, [
                  _c("p", { staticClass: "survey-hint" }, [
                    _vm._v(_vm._s(_vm.$t("flowSurvey3")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "option-grid" },
                    _vm._l(_vm.channelOptions, function(item) {
                      return _c(
                        "div",
                        {
                          key: item.id,
                          staticClass: "option-item",
                          class: { active: _vm.selectedIds.includes(item.id) },
                          on: {
                            click: function($event) {
                              return _vm.toggleOption(item.id)
                            }
                          }
                        },
                        [
                          _c("span", {
                            staticClass: "option-check",
                            class: {
                              checked: _vm.selectedIds.includes(item.id)
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "option-label" }, [
                            _vm._v(_vm._s(_vm.$t(item.i18nKey)))
                          ])
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "option-other",
                      class: { active: _vm.selectedIds.includes(_vm.OTHER_ID) },
                      on: {
                        click: function($event) {
                          return _vm.toggleOption(_vm.OTHER_ID)
                        }
                      }
                    },
                    [
                      _c("span", {
                        staticClass: "option-check",
                        class: {
                          checked: _vm.selectedIds.includes(_vm.OTHER_ID)
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "option-label other-label" }, [
                        _vm._v(_vm._s(_vm.$t("flowSurvey14")) + "：")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.otherText,
                            expression: "otherText"
                          }
                        ],
                        ref: "otherInput",
                        staticClass: "other-input",
                        attrs: {
                          type: "text",
                          maxlength: "50",
                          placeholder: _vm.$t("flowSurvey15")
                        },
                        domProps: { value: _vm.otherText },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.onOtherFocus.apply(null, arguments)
                          },
                          focus: _vm.onOtherFocus,
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.otherText = $event.target.value
                            },
                            _vm.onOtherFocus
                          ]
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "survey-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn-skip",
                      attrs: { type: "button" },
                      on: { click: _vm.handleSkip }
                    },
                    [_vm._v(_vm._s(_vm.$t("flowSurvey16")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn-submit",
                      class: { disabled: !_vm.canSubmit },
                      attrs: { type: "button", disabled: !_vm.canSubmit },
                      on: { click: _vm.handleSubmit }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("flowSurvey17")) +
                          "\n        "
                      )
                    ]
                  )
                ])
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-5e1cd52f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-5e1cd52f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/public/BloomSurveyDialog.vue
// module id = null
// module chunks = 